import {ChangeLeadTime, DAYS_IN_WEEK} from "../../api/models";
import _ from "lodash";
import dayjs from "dayjs";
import Utils from "../../util/util";
import {Tooltip} from "antd";
import {WarningOutlined} from "@ant-design/icons";
import React from "react";

const ProductionDateInfo = (props: {
    productionDate:Date | undefined
    leadTime:ChangeLeadTime | undefined
}) => {

    const { productionDate, leadTime } = props;

    if ( productionDate ) return <>{dayjs(productionDate).format('M/D/YYYY')}</>;

    const leadTimeDays = _.max([leadTime?.categoryLeadTimeDays, (leadTime?.standardLeadTimeWeeks || 0) * DAYS_IN_WEEK]);
    if( leadTimeDays ) {
        const dt = dayjs().add(leadTimeDays, 'day').format('M/D/YYYY');
        const categories = leadTime?.leadTimeCategories?.map(c => Utils.stripSortingPrefix(c.name)).join(", ");
        const leadTimeDescription = leadTimeDays === leadTime?.categoryLeadTimeDays
            ? `Production lead time of ${leadTime?.categoryLeadTimeDays} days due to: ${categories}.`
            : `Standard production lead time of ${leadTime?.standardLeadTimeWeeks} weeks.`;

        return <>{dt}
            <Tooltip title={leadTimeDescription}>
                <WarningOutlined style={{color:"orange", marginLeft: ".4rem"}} />
            </Tooltip>
        </>
    }

    return <>Not Available</>;
}

export default ProductionDateInfo;
